"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.networkDestroy = exports.networkCreate = exports.hurt = exports.createHammerheadClass = exports.hitByWeaponAt = exports.hitByWeapon = exports.update = exports.create = void 0;
var assert_sidecar_1 = require("@lib/assert-sidecar");
var distanceUtil_sidecar_1 = require("@lib/distanceUtil-sidecar");
var rando_sidecar_1 = require("@lib/rando-sidecar");
var common_1 = require("@main/common");
var common_sidecar_1 = require("@main/common-sidecar");
var diveCrew_hero_data_1 = require("@voyage/crew/diveCrew_hero_data");
var diveCrew_1 = require("@voyage/crew/diveCrew");
var voyageMessageCrewCreate_1 = require("@voyage/multi/voyageMessageCrewCreate");
var voyageMessageCrewCreate_sidecar_1 = require("@voyage/multi/voyageMessageCrewCreate-sidecar");
var voyageMessageEffectCommand_1 = require("@voyage/multi/voyageMessageEffectCommand");
var voyageMessageEffectCommand_sidecar_1 = require("@voyage/multi/voyageMessageEffectCommand-sidecar");
var voyageMessageEnemyShipCommand_1 = require("@voyage/multi/voyageMessageEnemyShipCommand");
var voyageMessageEnemyShipCommand_sidecar_1 = require("@voyage/multi/voyageMessageEnemyShipCommand-sidecar");
var voyageMessageMoney_sidecar_1 = require("@voyage/multi/voyageMessageMoney-sidecar");
var voyageGameStatus_sidecar_1 = require("@voyage/game-status/voyageGameStatus-sidecar");
var voyageWebsockets_sidecar_1 = require("@voyage/multi-sockets/voyageWebsockets-sidecar");
var voyageSounds_sidecar_1 = require("@voyage/sounds/voyageSounds-sidecar");
var voyageTilemap_sidecar_1 = require("@voyage/tilemap/voyageTilemap-sidecar");
function create() {
    return {
        active: false,
        class: 'Noclass',
        hitpoints: 0,
        fireTimer: 0,
        fireTime: 100,
        fireSize: 0,
        chanceBreach: 0,
        chanceFire: 0,
    };
}
exports.create = create;
function update() {
    var obj = voyageGameStatus_sidecar_1.voyageGameStatus.get();
    var ds = common_sidecar_1.common.getUpdateDeltaScaled();
    if (voyageWebsockets_sidecar_1.voyageWebsockets.getIsHost()) {
        var es = obj.enemyShip;
        if (es.active) {
            es.fireTimer += ds;
            if (es.fireTimer > es.fireTime) {
                es.fireTimer -= es.fireTime;
                hitByWeapon(es.fireSize, es.chanceFire, es.chanceBreach);
            }
        }
    }
}
exports.update = update;
function hitByWeapon(size, chanceFire, chanceBreach, shake) {
    if (shake === void 0) { shake = true; }
    assert_sidecar_1.assert.t(voyageWebsockets_sidecar_1.voyageWebsockets.getIsHost());
    var floor = voyageTilemap_sidecar_1.voyageTilemap.getRandomFloor();
    hitByWeaponAt(floor, size, chanceFire, chanceBreach, shake);
}
exports.hitByWeapon = hitByWeapon;
function hitByWeaponAt(t, size, chanceFire, chanceBreach, shake) {
    if (shake === void 0) { shake = true; }
    assert_sidecar_1.assert.t(voyageWebsockets_sidecar_1.voyageWebsockets.getIsHost());
    var floor = t;
    var r = Math.ceil(size);
    voyageMessageEffectCommand_sidecar_1.voyageMessageEffectCommand.sendMessageAndImmediatelyExecute({
        command: voyageMessageEffectCommand_1.EEffectCommand.HitParticles,
        x: floor.x,
        y: floor.y,
        num: 5 * size,
    });
    // voyageParticles.createMultiple('weapon-hit', floor.x, floor.y, 5 * size)
    var createdFire = 0;
    var createdBreach = 0;
    //console.log('breach', es.fireSize)
    for (var i = -r; i <= r; i++) {
        for (var j = -r; j <= r; j++) {
            var d = distanceUtil_sidecar_1.distanceUtil.distanceNormal(i, j, 0, 0);
            //let d = 0/
            if (d <= size) {
                var t_1 = voyageTilemap_sidecar_1.voyageTilemap.getSafeOffset(floor, i, j);
                // console.log('breach t', t)
                if (t_1 && t_1.tile2.canWalk) {
                    if (!t_1.breach && !t_1.fire) {
                        if (rando_sidecar_1.rando.chance(chanceFire)) {
                            createdFire++;
                            voyageMessageCrewCreate_sidecar_1.voyageMessageCrewCreate.sendMessageAndImmediatelyExecute({
                                crewId: common_1.createId(),
                                team: -1,
                                method: voyageMessageCrewCreate_1.EVoyageCrewCreateMethod.Normal,
                                i: t_1.i,
                                j: t_1.j,
                                type: diveCrew_1.EVoyageCrewType.Fire,
                                heroType: diveCrew_hero_data_1.EDiveHeroSubtype.None,
                                enemyType: '',
                                energy: 0,
                                hitpoints: 15,
                            });
                            //let cr = diveCrew.create(EVoyageCrewType.Fire, -1)
                            // diveCrew.moveToIJ(cr, t)
                        }
                        else if (rando_sidecar_1.rando.chance(chanceBreach)) {
                            createdBreach++;
                            voyageMessageCrewCreate_sidecar_1.voyageMessageCrewCreate.sendMessageAndImmediatelyExecute({
                                crewId: common_1.createId(),
                                team: -1,
                                method: voyageMessageCrewCreate_1.EVoyageCrewCreateMethod.Normal,
                                i: t_1.i,
                                j: t_1.j,
                                type: diveCrew_1.EVoyageCrewType.HullBreach,
                                heroType: diveCrew_hero_data_1.EDiveHeroSubtype.None,
                                enemyType: '',
                                energy: 0,
                                hitpoints: 15,
                            });
                            // let cr = diveCrew.create(EVoyageCrewType.HullBreach, -1)
                            // diveCrew.moveToIJ(cr, t)
                            // createdBreach++
                        }
                    }
                }
            }
        }
    }
    // Effects
    if (createdFire > 0) {
    }
    if (createdBreach > 0) {
        voyageMessageEffectCommand_sidecar_1.voyageMessageEffectCommand.sendMessageAndImmediatelyExecute({
            command: voyageMessageEffectCommand_1.EEffectCommand.HitBreach,
        });
    }
    if (createdFire > createdBreach) {
        voyageMessageEffectCommand_sidecar_1.voyageMessageEffectCommand.sendMessageAndImmediatelyExecute({
            command: voyageMessageEffectCommand_1.EEffectCommand.HitFire,
        });
    }
    else {
        voyageMessageEffectCommand_sidecar_1.voyageMessageEffectCommand.sendMessageAndImmediatelyExecute({
            command: voyageMessageEffectCommand_1.EEffectCommand.HitExplosion,
        });
    }
    if (shake) {
        voyageMessageEffectCommand_sidecar_1.voyageMessageEffectCommand.sendMessageAndImmediatelyExecute({
            command: voyageMessageEffectCommand_1.EEffectCommand.Shake,
        });
    }
}
exports.hitByWeaponAt = hitByWeaponAt;
// export function networkHitByWeapon() {}
function createHammerheadClass() {
    var obj = voyageGameStatus_sidecar_1.voyageGameStatus.get();
    var es = obj.enemyShip;
    es.chanceFire = 0.1;
    es.chanceBreach = 0.3;
    es.fireTime = 10;
    es.fireTimer = 0;
    es.fireSize = 1.5;
    es.hitpoints = 100;
    es.class = 'Hammerhead';
    es.active = true;
}
exports.createHammerheadClass = createHammerheadClass;
function hurt(damage) {
    if (voyageWebsockets_sidecar_1.voyageWebsockets.getIsHost()) {
        var obj = voyageGameStatus_sidecar_1.voyageGameStatus.get();
        var es = obj.enemyShip;
        if (es.active) {
            es.hitpoints -= damage;
            if (es.hitpoints <= 0) {
                voyageMessageEnemyShipCommand_sidecar_1.voyageMessageEnemyShipCommand.sendMessageAndImmediatelyExecute({
                    command: voyageMessageEnemyShipCommand_1.EVoyageEnemyShipCommand.Destroy,
                });
                voyageMessageMoney_sidecar_1.voyageMessageMoney.sendMessageAndImmediatelyExecute({
                    money: voyageGameStatus_sidecar_1.voyageGameStatus.get().money + 150,
                });
            }
        }
    }
}
exports.hurt = hurt;
function networkCreate(msg) {
    var obj = voyageGameStatus_sidecar_1.voyageGameStatus.get();
    var es = obj.enemyShip;
    es.active = false;
    voyageGameStatus_sidecar_1.voyageGameStatus.addShipsDead();
    setTimeout(function () {
        voyageSounds_sidecar_1.voyageSounds.playEnemyShipDefeated();
    }, 2000);
}
exports.networkCreate = networkCreate;
function networkDestroy(msg) {
    var obj = voyageGameStatus_sidecar_1.voyageGameStatus.get();
    var es = obj.enemyShip;
    es.active = false;
    voyageGameStatus_sidecar_1.voyageGameStatus.addShipsDead();
    setTimeout(function () {
        voyageSounds_sidecar_1.voyageSounds.playEnemyShipDefeated();
    }, 2000);
}
exports.networkDestroy = networkDestroy;
